/**
 * Converts an uploaded File object into a Base64 Data URL using the FileReader API.
 * @param {File} file - The file object to convert.
 * @returns {Promise<string>} A promise that resolves with the Base64 Data URL string.
 */
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    if (!(file instanceof File)) {
      return reject(new Error("Invalid input: Argument must be an instance of File."));
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export default fileToBase64;
